import { t } from 'i18next';
import { useState } from 'react';

import { Button } from 'core/components';
import { TextLine } from 'core/elements';
import { IAttributePartPayload, IQuotePart } from 'quotes/types';
import { Color, Variant } from 'theme/enums';

import { AttributePartDetails } from './AttributePartDetails';
import { AttributePartType } from './enums';

interface IProps {
  type: AttributePartType;
  selectedPart: IQuotePart;
  onAttachParts?: (parts: IAttributePartPayload[]) => Promise<{ newRows: IQuotePart[] }>;
  inlineButton?: boolean;
}

export const SelectAttributePartButton = ({
  type,
  selectedPart,
  onAttachParts,
  inlineButton = true,
}: IProps) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);

  return (
    <>
      {inlineButton && (
        <TextLine
          text={t('messageSelectPart')}
          onClick={() => setIsDetailsOpen(true)}
          color={Color.PRIMARY}
          isSubText
        />
      )}

      {!inlineButton && (
        <Button
          text={t('labelSelectPart')}
          onClick={() => setIsDetailsOpen(true)}
          variant={Variant.PLAIN}
        />
      )}

      <AttributePartDetails
        type={type}
        isOpen={isDetailsOpen}
        onClose={() => setIsDetailsOpen(false)}
        selectedPart={selectedPart}
        onAttachParts={onAttachParts}
      />
    </>
  );
};
